import { Component, OnInit, Input, Output, EventEmitter, OnChanges } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import {
  getCalendarDateObj,
  getDateFromCalendarObj,
  isWeekendAndHolidayDisabled
} from 'appRootPath/utils';
import { NgbDateStruct, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import {
  DOCUMENT_NAME_MAP, LISTING_DOC_NAME_ID_MAP, BSE_ANNEXURE_A,
  BSE_ANNEXURE_B_FURTHER, BSE_ANNEXURE_A_FORM_A, API_DATE_FORMAT, MODAL_OPTIONS,
  NSE_ANNEXURE_A,
  NSE_ANNEXURE_B_FURTHER
} from 'appRootPath/shared/global-meta-data';
import { SimpleSigningModalComponent } from '../simple-signing-modal/simple-signing-modal.component';
import { CpMarketplaceApiService } from 'appRootPath/services/cp-marketplace-api.service';
import { ViewDocsModalComponent } from '../view-docs-modal/view-docs-modal.component';
import { ListingExtradataModalComponent } from '../listing-extradata-modal/listing-extradata-modal.component';
import { ToastrService } from 'ngx-toastr';
import { COMMON_MESSAGES } from 'appRootPath/messages';


@Component({
  selector: 'app-issue-listing-sidepanel',
  templateUrl: './issue-listing-sidepanel.component.html',
  styleUrls: ['./issue-listing-sidepanel.component.scss']
})
export class IssueListingSidepanelComponent implements OnInit, OnChanges {
  @Input() isShown = false;
  @Input() pastListings = [];
  @Output() sidebarStateChange = new EventEmitter(false);

  isWeekendAndHolidayDisabled = isWeekendAndHolidayDisabled;
  documentNames = DOCUMENT_NAME_MAP;
  listingDocNameIdMap = LISTING_DOC_NAME_ID_MAP;
  isAdditionalDataDoc = {
    [BSE_ANNEXURE_A]: true,
    [BSE_ANNEXURE_B_FURTHER]: true,
    [NSE_ANNEXURE_A]: true,
    [NSE_ANNEXURE_B_FURTHER]: true
  };
  listingForm: FormGroup;
  stockExchangeList = [{
    name: 'BSE',
    id: 'BSE'
  }, {
    name: 'NSE',
    id: 'NSE'
  }, {
    name: 'BOTH',
    id: 'BOTH'
  }];

  scrollOptions = {
    wheelPropagation: true,
    suppressScrollX: true
  }

  listingOverallStatus = {
    UNSIGNED: 'Provide additional data (if any), preview the docs and send for signing.',
    SENT_FOR_SIGN: 'Waiting for signatories to sign the documents',
    SIGNED: 'All documents have been signed'
  };

  today: NgbDateStruct;
  documents = [];
  listingId = null;
  listedIssues = [];

  authorisedSignatories = [];
  allDocsSentForSign = false;
  allDocsSigned = false;
  allDocsUnsigned = false;
  constructor(
    private apiService: CpMarketplaceApiService,
    private listFb: FormBuilder,
    private modalService: NgbModal,
    private toastr: ToastrService
  ) { }

  ngOnInit() {
    this.today = getCalendarDateObj(new Date());
  }

  ngOnChanges(changes) {
    if (changes && changes.isShown && changes.isShown.currentValue) {
      this.clearSidebarData();
      this.listingForm = this.listFb.group({
        stock_exchange: [null, Validators.required],
        listing_date: [null, Validators.required]
      });


      this.apiService.getSignatories().subscribe((resp: any) => {
        if (!resp.error) {
          this.authorisedSignatories = resp[0].signatories;
        }
      });

      this.addFormSubscriptions();
    }
  }

  clearSidebarData() {
    this.documents = [];
    this.listingId = null;
    this.listedIssues = [];
    this.allDocsSentForSign = false;
    this.allDocsSigned = false;
    this.allDocsUnsigned = false;
  }

  addFormSubscriptions() {
    this.listingForm.get('listing_date').valueChanges.subscribe(() => {
      this.clearSidebarData();
    });
  }


  getListingDocuments() {
    const listingFormData = {
      listing_date: getDateFromCalendarObj(this.listingForm.value.listing_date).format(API_DATE_FORMAT),
      stock_exchange: this.listingForm.value.stock_exchange,
    };

    this.apiService.getExistingListingDocs(listingFormData).
    subscribe((listingDocs: any) => {

      if (listingDocs && listingDocs.length > 0 && listingDocs[0].stock_exchange && listingDocs[0].under_scrip_code_nse == null) {
        this.documents =
          this.processDocState(listingDocs[0].documents, listingDocs[0].under_scrip_code_bse,null, null);
        this.listingId = listingDocs[0].id;
        this.listingForm.get('stock_exchange').patchValue([listingDocs[0].stock_exchange]);
        this.listedIssues = listingDocs[0].listed_issues;

      } else if (listingDocs && listingDocs.length > 0 && listingDocs[0].under_scrip_code_nse && listingDocs[0].under_scrip_code_bse==null) {
        this.documents =
          this.processDocState(listingDocs[0].documents,null, listingDocs[0].under_scrip_code_nse, null);
        this.listingId = listingDocs[0].id;
        this.listingForm.get('stock_exchange').patchValue([listingDocs[0].stock_exchange]);
        this.listedIssues = listingDocs[0].listed_issues;

      } else if (listingDocs && listingDocs.length > 0 && listingDocs[0].under_scrip_code_bse && listingDocs[0].under_scrip_code_nse) {
        this.documents =
          this.processDocState(listingDocs[0].documents,listingDocs[0].under_scrip_code_bse, listingDocs[0].under_scrip_code_nse, null);
        this.listingId = listingDocs[0].id;
        this.listingForm.get('stock_exchange').patchValue([listingDocs[0].stock_exchange]);
        this.listedIssues = listingDocs[0].listed_issues;

      } else {
        this.apiService.getFreshListingDocs(listingFormData).subscribe((docsResp) => {
          this.parseFreshDocs(docsResp);
        });
      }
    });
  }

  parseFreshDocs(docsResp) {
    this.listingId = docsResp.id;
    this.listedIssues = docsResp.listed_issues;
    if (docsResp.under_scrip_code_bse==null && docsResp.stock_exchange == "BSE"){
    this.documents = this.processDocState(docsResp.documents, docsResp.under_scrip_code_bse, null, this.listedIssues);
  } else if (docsResp.under_scrip_code_nse==null && docsResp.stock_exchange == "NSE"){
    this.documents = this.processDocState(docsResp.documents,null, docsResp.under_scrip_code_nse, this.listedIssues);
  } else if (docsResp.under_scrip_code_nse==null && docsResp.under_scrip_code_nse==null && docsResp.stock_exchange == "BOTH"){
    this.documents = this.processDocState(docsResp.documents, docsResp.under_scrip_code_bse, docsResp.under_scrip_code_nse, this.listedIssues);
  }
  }

  processDocState(documents, under_scrip_code_bse, under_scrip_code_nse, issues) {
    if (!documents) {
      return [];
    }
    this.allDocsSentForSign = false;
    this.allDocsSigned = false;
    let allDocsSigned = true;
    let allDocsSentSign = true;
    const retDocs = documents.map((doc) => {
      const classes = [];
      const newDocObj = Object.assign({}, doc, doc.state);
      delete newDocObj.state;
      if (under_scrip_code_bse && under_scrip_code_nse==null && newDocObj.name === BSE_ANNEXURE_B_FURTHER) {

        newDocObj.extra_data = {
          under_scrip_code_bse
        };
      } else if (under_scrip_code_nse && under_scrip_code_bse==null && newDocObj.name === NSE_ANNEXURE_B_FURTHER) {
        newDocObj.extra_data = {
          under_scrip_code_nse
        };

      } else if (under_scrip_code_nse && under_scrip_code_bse && (newDocObj.name === NSE_ANNEXURE_B_FURTHER || newDocObj.name === BSE_ANNEXURE_B_FURTHER)){
          newDocObj.extra_data = {
            under_scrip_code_bse , under_scrip_code_nse
          };
      }
      if (newDocObj.name === BSE_ANNEXURE_A && newDocObj.extra_data &&
        newDocObj.extra_data.length) {
        newDocObj.extra_data.forEach((listing) => {
          if (Object.values(listing) && Object.values(listing).length) {
            if (Object.values(listing)[0] === null) {
              newDocObj.extraDataReqd = true;
            } else if (Object.values(listing)[0]['issue_opening_date'] === null) {
              newDocObj.extraDataReqd = true;
            }
          }
        });

      } else if (newDocObj.name === NSE_ANNEXURE_A && newDocObj.extra_data &&
        newDocObj.extra_data.length) {
        newDocObj.extra_data.forEach((listing) => {
          if (Object.values(listing) && Object.values(listing).length) {
            if (Object.values(listing)[0] === null) {
              newDocObj.extraDataReqd = true;
            } else if (Object.values(listing)[0]['issue_opening_date'] === null) {
              newDocObj.extraDataReqd = true;
            }
          }
        });

      }
      newDocObj.iconClass = 'float-right fa fa-lg cp-icon-size';
      newDocObj.iconClasses = [];
      newDocObj.additionalText = null;
      newDocObj.classes = null;

      allDocsSentSign = allDocsSentSign && newDocObj.documents_sent_for_signing;
      allDocsSigned = allDocsSigned && newDocObj.is_signed;

      if (newDocObj.is_signed) {
        newDocObj.iconClasses.push('fa-check-circle cp-green-icon');
      } else if (this.isAdditionalDataDoc[newDocObj.name] &&
        (newDocObj.extraDataReqd || !newDocObj.extra_data)) {
        classes.push('no-added-data');
        newDocObj.iconClasses.push('fa-exclamation');
        newDocObj.additionalText = 'Provide Additional details.';
      } else {
        classes.push('for-icon-right');
        classes.push('for-pdf');
      }

      newDocObj.classes = classes.join(' ');
      return newDocObj;
    });
    this.allDocsSigned = allDocsSigned;
    this.allDocsSentForSign = allDocsSentSign;
    this.allDocsUnsigned = !allDocsSentSign && !allDocsSigned;
    // console.log(retDocs);
    return retDocs;
  }

  handleDocumentAction(document) {
    const listingDate = getDateFromCalendarObj(this.listingForm.value.listing_date).format(API_DATE_FORMAT);
    if (!listingDate) {
      return;
    }
    if (document.is_signed) {
      this.viewDocument(document.name, document.document_url);
    } else if (this.isAdditionalDataDoc[document.name] && (document.extraDataReqd || !document.extra_data)) {
      this.showExtraDataModal(document, listingDate);
    } else {
      this.generateDocument(document, listingDate);
    }

  }

  generateDocument(document, listingDate, refreshAfterView = false) {
    return this.apiService.generateListingDoc(
      this.listingDocNameIdMap[document.name],
      listingDate
    ).subscribe((docUrl) => {
      this.viewDocument(document.name, docUrl, refreshAfterView);
    });
  }

  viewDocument(documentKey, url, refreshAfterView = false) {
    if (!url) {
      this.toastr.warning(COMMON_MESSAGES.RESOURCE_NOT_FOUND);
      return;
    }
    const modalRef = this.modalService.open(ViewDocsModalComponent, { backdrop: 'static', keyboard: false });
    modalRef.componentInstance.docsToView = [
      {
        title: this.documentNames[documentKey],
        document_url: url
      }
    ];
    modalRef.result.then(() => {
      if (refreshAfterView) {
        window.setTimeout(() => {
          this.getListingDocuments();
        }, 500);
      }
    });
  }

  showExtraDataModal(document, listingDate) {
    const modalRef = this.modalService.open(ListingExtradataModalComponent, MODAL_OPTIONS);
    modalRef.componentInstance.documentKey = document.name;
    modalRef.componentInstance.extraDocData = document.extra_data;
    modalRef.componentInstance.listedIssues = this.listedIssues;
    modalRef.componentInstance.listingId = this.listingId;
    modalRef.componentInstance.listingDate = listingDate;
    modalRef.result.then(result => {
      if (result) {
        this.generateDocument(document, listingDate, true);
      }
    });
  }

  closeSidePanel() {
    this.isShown = false;
    this.sidebarStateChange.emit(false);
  }

  showSignatoryModal() {
    const modalRef = this.modalService.open(SimpleSigningModalComponent, {
      backdrop: 'static',
      keyboard: false,
      size: 'sm'
    });
    modalRef.componentInstance.modalInputs = {
      listingId: this.listingId,
      signatoriesList: this.authorisedSignatories,
      documents: this.documents
    };

    modalRef.result.then(result => {
      if (result) {
        this.closeSidePanel();
      }
    });
  }

}
